import { blobToDataURL } from './blobToDataURL';
import { ImagePreviewResponse } from './getVideoCover';
import { getMediaProportion } from './media';

export const createImageThumbnail = (
  file: File,
  thumbnailSize = 320,
  imageQuality = 1
): Promise<ImagePreviewResponse> =>
  new Promise<ImagePreviewResponse>((resolve, reject) => {
    const image = document.createElement('img');
    image.setAttribute('src', URL.createObjectURL(file));
    image.addEventListener('load', () => {
      const canvas = document.createElement('canvas');
      const smallestSize = Math.min(image.width, image.height);
      const resizerRatio = thumbnailSize / smallestSize;
      const canvasX = Math.ceil(image.width * resizerRatio);
      const canvasY = Math.ceil(image.height * resizerRatio);
      canvas.width = canvasX;
      canvas.height = canvasY;
      const proportion = getMediaProportion(image.width, image.height);
      // draw the video frame to canvas
      const ctx = canvas.getContext('2d');
      if (!ctx) reject('Could not get canvas 2d context');
      if (ctx) {
        ctx.drawImage(image, 0, 0, canvasX, canvasY);
        ctx.canvas.toBlob(
          async blob => {
            if (blob) {
              try {
                const result = await blobToDataURL(blob);
                resolve({
                  preview: result,
                  proportion,
                  width: image.width,
                  height: image.height,
                  length: null
                });
              } catch (e) {
                reject(e);
              }
            } else {
              reject('Canvas to Blob failed');
            }
          },
          'image/jpeg',
          imageQuality
        );
      }
    });
    image.addEventListener('error', () => {
      reject('Image load Failed');
    });
  });
